/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Role_MemberInputs */

const en_us2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

const pt_br2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro`)
};

const es_419_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro`)
};

const pt_pt2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro`)
};

const fr_fr2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre`)
};

const de_de2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied`)
};

const it_it2_clubs_role_member = /** @type {(inputs: Clubs_Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membro`)
};

/**
* | output |
* | --- |
* | "Member" |
*
* @param {Clubs_Role_MemberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_role_member = /** @type {((inputs?: Clubs_Role_MemberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Role_MemberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_role_member(inputs)
	if (locale === "es-419") return es_419_clubs_role_member(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_role_member(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_role_member(inputs)
	if (locale === "de-DE") return de_de2_clubs_role_member(inputs)
	if (locale === "it-IT") return it_it2_clubs_role_member(inputs)
	return en_us2_clubs_role_member(inputs)
});
export { clubs_role_member as "clubs.role_member" }